import keyBy from 'lodash/keyBy';
import type { ParsedQuery } from 'query-string';

import { serializeActionDate } from 'modules/search/helpers/actionDateSerializer';
import type {
  SearchFacet,
  SearchFacetId,
} from 'modules/search/types/SearchFacet';
import type { SearchFiltersById } from 'modules/search/types/SearchFiltersById';
import { mapObject } from 'utils/functional/object';

import { almostSavedSearchSerializableDataStructure } from './almostSavedSearchSerializableDataStructure';

type Args = {
  filtersById: SearchFiltersById;
  queryParams: ParsedQuery;
  searchFacets: SearchFacet[];
  timezone?: string | null;
};

// serializeFiltersForSavedSearch takes the redux filter state and outputs
// a saved-search-serializable data structure. See `stateSearchFilters`
export function serializeFiltersForSavedSearch({
  filtersById,
  queryParams,
  searchFacets,
  timezone,
}: Args) {
  const searchFacetById = keyBy(searchFacets, 'id');

  const data = almostSavedSearchSerializableDataStructure({
    filtersById,
    searchFacets,
  });

  const updatedData = {
    ...data,
    // @ts-expect-error fix types
    ...serializeActionDate(timezone!, data.endsGT, data.startsLT),
  };

  return mapObject(
    // @ts-expect-error fix types
    updatedData,
    (key: SearchFacetId, value) => {
      if (['type', 'startsLT', 'endsGT'].includes(key)) {
        return [key, value];
      }

      if (searchFacetById[key].type === 'string') {
        return [
          searchFacetById[key].name,
          queryParams[searchFacetById[key].name] || value,
        ];
      }

      return [searchFacetById[key].name, value];
    },
  );
}
